import type { RootState } from '~/store';

// Base selector
export const applicationsSelector = (state: RootState) => state.applications;
export const applicationsIsFetchingJoinClanSelector = (state: RootState) => state.applications.isFetchingJoinClan;
